import CityDirectory from "../components/CityDirectory";

export default function UkCities() {
  return (
    <CityDirectory
      id="uk-cities"
      title="United Kingdom City Guides"
      subtitle="90+ places across England, Scotland, Wales and Northern Ireland — cities, historic towns, seaside resorts and iconic destinations like Stonehenge, the Lake District and the Isle of Skye."
      endpoint="/geo/uk-cities"
      country="United Kingdom"
      searchPlaceholder="Search a city or region — try Edinburgh, Wales, Bath…"
      accent="#012169"
      docTitle="United Kingdom City Guides — Cities by Region | TravelerPulse"
    />
  );
}
